import { Button } from "antd";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setType } from "../../../redux/slices/dashboard_slice";

const DashboardMainHeader = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const type = useSelector((state) => state.dashboard.type);

  const navigateTabHandler = (selectedType) => {
    dispatch(setType(selectedType));
  };

  const getClassName = (typeArg) => (typeArg === type ? "active" : "");
  const containerRef = useRef();
  useEffect(() => {
    if (containerRef) {
      containerRef.current.scrollTo({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      window.scrollTo({ top: 0 });
    }
  }, [containerRef]);
  return (
    <>
      <div className="row dashboard-tabs-btn" ref={containerRef}>
        <div className="col-12">
          <ul className="list-inline mb-0">
            <li
              className="list-inline-item"
              onClick={() => navigateTabHandler("all")}
            >
              <Button className={getClassName("all")}>
                {t("dashboard.all")}
              </Button>
            </li>
            <li
              className="list-inline-item"
              onClick={() => navigateTabHandler("income")}
            >
              <Button className={getClassName("income")}>
                {t("dashboard.income")}
              </Button>
            </li>
            <li
              className="list-inline-item"
              onClick={() => navigateTabHandler("expense")}
            >
              <Button className={getClassName("expense")}>
                {t("dashboard.expenses")}
              </Button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default DashboardMainHeader;
